(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amarelle_countdown_bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  const bar = document.querySelector('[data-amarelle-countdown-bar]');
  if (!bar) return;

  const dismissBtn = bar.querySelector('[data-amarelle-countdown-dismiss]');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', function() {
      bar.hidden = true;
    });
  }

  const timerEl = bar.querySelector('[data-amarelle-countdown]');
  if (!timerEl) return;
  const endDate = new Date(timerEl.dataset.amarelleCountdown).getTime();
  if (isNaN(endDate)) return;

  const daysEl    = bar.querySelector('[data-amarelle-countdown-days]');
  const hoursEl   = bar.querySelector('[data-amarelle-countdown-hours]');
  const minsEl    = bar.querySelector('[data-amarelle-countdown-minutes]');
  const secsEl    = bar.querySelector('[data-amarelle-countdown-seconds]');

  function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

  function tick() {
    const diff = endDate - Date.now();
    if (diff <= 0) {
      if (daysEl)  daysEl.textContent  = '00';
      if (hoursEl) hoursEl.textContent = '00';
      if (minsEl)  minsEl.textContent  = '00';
      if (secsEl)  secsEl.textContent  = '00';
      return;
    }
    if (daysEl)  daysEl.textContent  = pad(Math.floor(diff / 86400000));
    if (hoursEl) hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    if (minsEl)  minsEl.textContent  = pad(Math.floor((diff % 3600000) / 60000));
    if (secsEl)  secsEl.textContent  = pad(Math.floor((diff % 60000) / 1000));
  }

  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function(){
  var root = document.querySelector('[data-amarelle-pdp]');
  if (!root) return;
  var form = root.querySelector('[data-pdp-form]');
  var variantInput = root.querySelector('[data-pdp-variant-id]');
  var variantsScript = root.querySelector('[data-pdp-variants]');
  var variants = [];
  try { variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]'); } catch(e) { variants = []; }
  var colorPosition = parseInt(root.getAttribute('data-color-position') || '0', 10);
  var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]'));
  var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-media-item]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
  var priceEl = root.querySelector('[data-pdp-price]');
  var compareEl = root.querySelector('[data-pdp-compare]');
  var saleEl = root.querySelector('[data-pdp-sale]');
  var soldoutEl = root.querySelector('[data-pdp-soldout]');
  var buyEl = root.querySelector('[data-pdp-buy]');
  var paymentEl = root.querySelector('[data-pdp-payment]');
  var addBtn = root.querySelector('[data-pdp-add]');
  var stockEl = root.querySelector('[data-pdp-stock]');
  var mobileAtc = document.querySelector('[data-pdp-mobile-atc]');
  var mobilePrice = document.querySelector('[data-pdp-mobile-price]');
  var mobileSubmit = document.querySelector('[data-pdp-mobile-submit]');

  function money(cents){
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, root.dataset.moneyFormat || ('{' + '{amount}' + '}'));
    var value = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    return '€' + value;
  }
  function handleize(str){
    return String(str || '').toLowerCase().trim().replace(/kleur:|color:|colour:/g,'').normalize ? String(str || '').toLowerCase().trim().replace(/kleur:|color:|colour:/g,'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'') : String(str || '').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  }
  function selectedOptions(){
    var count = 0;
    optionInputs.forEach(function(input){ count = Math.max(count, parseInt(input.dataset.optionPosition || '0', 10)); });
    var selected = new Array(count);
    optionInputs.forEach(function(input){
      if (!input.checked) return;
      selected[parseInt(input.dataset.optionPosition,10)-1] = input.value;
    });
    return selected;
  }
  function exactVariant(){
    var selected = selectedOptions();
    return variants.find(function(v){
      return selected.every(function(value, index){ return !value || v.options[index] === value; });
    });
  }
  function selectedColorKey(){
    if (!colorPosition) return '';
    var input = root.querySelector('[data-pdp-option][data-option-position="' + colorPosition + '"]:checked');
    return input ? handleize(input.value) : '';
  }
  function setActiveMedia(mediaId){
    var visible = mediaItems.filter(function(item){ return !item.classList.contains('is-filtered-out'); });
    var target = mediaId ? mediaItems.find(function(item){ return item.dataset.mediaId == mediaId && !item.classList.contains('is-filtered-out'); }) : null;
    if (!target) target = visible[0];
    if (!target) return;
    mediaItems.forEach(function(item){ item.classList.toggle('is-active', item === target); });
    thumbs.forEach(function(thumb){ thumb.classList.toggle('is-active', thumb.dataset.mediaId == target.dataset.mediaId); });
    if (window.matchMedia('(max-width: 760px)').matches) {
      var strip = root.querySelector('[data-pdp-thumbs]');
      var activeThumb = thumbs.find(function(thumb){ return thumb.dataset.mediaId == target.dataset.mediaId; });
      if (strip && activeThumb && strip.scrollTo) {
        var x = activeThumb.offsetLeft - (strip.clientWidth - activeThumb.clientWidth) / 2;
        strip.scrollTo({ left: Math.max(0, x), behavior: 'smooth' });
      }
    }
  }
  function applyMediaFilter(preferredMediaId){
    var color = selectedColorKey();
    var anyColoredMatch = false;
    if (color) {
      anyColoredMatch = mediaItems.some(function(item){ return item.dataset.mediaColor === color; });
    }
    mediaItems.forEach(function(item){
      var key = item.dataset.mediaColor || '';
      var show = !color || !anyColoredMatch || !key || key === color;
      item.classList.toggle('is-filtered-out', !show);
    });
    thumbs.forEach(function(thumb){
      var key = thumb.dataset.mediaColor || '';
      var show = !color || !anyColoredMatch || !key || key === color;
      thumb.classList.toggle('is-filtered-out', !show);
    });
    setActiveMedia(preferredMediaId);
  }
  function updateOptionVisuals(){
    var selected = selectedOptions();
    optionInputs.forEach(function(input){
      var pos = parseInt(input.dataset.optionPosition,10) - 1;
      var test = selected.slice();
      test[pos] = input.value;
      var possible = variants.some(function(v){
        if (!v.available) return false;
        return test.every(function(value, index){ return !value || v.options[index] === value; });
      });
      var label = root.querySelector('label[for="' + input.id + '"]');
      if (label) {
        label.classList.toggle('is-selected', input.checked);
        label.classList.toggle('is-unavailable', !possible);
      }
      input.disabled = !possible && !input.checked;
    });
    if (colorPosition) {
      var colorInput = root.querySelector('[data-pdp-option][data-option-position="' + colorPosition + '"]:checked');
      root.querySelectorAll('[data-pdp-selected-color]').forEach(function(el){ el.textContent = colorInput ? colorInput.value : ''; });
    }
  }
  function updateStock(variant){
    if (!stockEl || !variant) return;
    var threshold = parseInt(stockEl.dataset.threshold || '10', 10);
    var lowLabel = stockEl.dataset.lowLabel || 'Only {count} left in stock';
    var okLabel = stockEl.dataset.okLabel || 'In stock';
    var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
    stockEl.innerHTML = '';
    if (!variant.available) return;
    if (qty !== null && qty > 0 && qty <= threshold) stockEl.innerHTML = '<span class="is-low">' + lowLabel.replace('{count}', qty) + '</span>';
    else stockEl.innerHTML = '<span>' + okLabel + '</span>';
  }
  function updateVariant(variant, updateUrl){
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    if (priceEl) {
      priceEl.textContent = money(variant.price);
      priceEl.classList.toggle('no-sale', !(variant.compare_at_price && variant.compare_at_price > variant.price));
    }
    if (mobilePrice) mobilePrice.textContent = money(variant.price);
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = onSale ? money(variant.compare_at_price) : ''; }
    if (saleEl) {
      saleEl.hidden = !onSale;
      saleEl.textContent = onSale ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% Off' : '';
    }
    if (soldoutEl) soldoutEl.hidden = !!variant.available;
    if (buyEl) buyEl.hidden = !variant.available;
    if (paymentEl) paymentEl.hidden = !variant.available;
    if (mobileAtc) mobileAtc.hidden = !variant.available;
    if (addBtn) { addBtn.disabled = !variant.available; addBtn.textContent = variant.available ? (addBtn.dataset.available || 'Add to bag') : (addBtn.dataset.sold || 'Sold out'); }
    updateStock(variant);
    applyMediaFilter(variant.featured_media ? variant.featured_media.id : null);
    if (updateUrl && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    document.dispatchEvent(new CustomEvent('amarelle:variant-change', { detail: { variant: variant } }));
  }
  optionInputs.forEach(function(input){
    input.addEventListener('change', function(){
      updateOptionVisuals();
      var v = exactVariant();
      updateVariant(v, true);
    });
  });
  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){ setActiveMedia(thumb.dataset.mediaId); });
  });
  root.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = root.querySelector('[data-pdp-quantity]');
      if (!input) return;
      var val = Math.max(1, parseInt(input.value || '1', 10));
      input.value = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(1, val - 1);
    });
  });
  if (mobileSubmit && form) mobileSubmit.addEventListener('click', function(){ form.requestSubmit ? form.requestSubmit() : form.submit(); });
  if (form) {
    form.addEventListener('submit', function(event){
      var extras = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-mix-id]:checked')).map(function(input){ return { id: Number(input.dataset.pdpMixId), quantity: 1 }; });
      if (!extras.length || !window.fetch) return;
      event.preventDefault();
      var qtyInput = root.querySelector('[data-pdp-quantity]');
      var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
      var items = [{ id: Number(variantInput.value), quantity: qty }].concat(extras);
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding...'; }
      fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
        .then(function(){
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          if (addBtn) addBtn.textContent = 'Added';
          setTimeout(function(){ if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.available || 'Add to bag'; } }, 1200);
        })
        .catch(function(){ form.submit(); });
    });
  }
  var startX = 0, startY = 0;
  var mediaGrid = root.querySelector('[data-pdp-media-grid]');
  if (mediaGrid) {
    mediaGrid.addEventListener('touchstart', function(e){ if(!e.touches.length) return; startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive:true });
    mediaGrid.addEventListener('touchend', function(e){
      if(!e.changedTouches.length || !window.matchMedia('(max-width: 760px)').matches) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      var visible = mediaItems.filter(function(item){ return !item.classList.contains('is-filtered-out'); });
      var active = visible.findIndex(function(item){ return item.classList.contains('is-active'); });
      var next = Math.max(0, Math.min(visible.length - 1, active + (dx < 0 ? 1 : -1)));
      if (visible[next]) setActiveMedia(visible[next].dataset.mediaId);
    }, { passive:true });
  }
  updateOptionVisuals();
  updateVariant(exactVariant() || variants[0], false);
})();

(function(){
  var root = document.querySelector('[data-amarelle-pdp]');
  var lightbox = document.querySelector('[data-pdp-lightbox]');
  if (!root || !lightbox) return;
  var img = lightbox.querySelector('[data-lightbox-image]');
  var current = 0;
  function sources(){
    return Array.prototype.slice.call(root.querySelectorAll('[data-pdp-lightbox-open]')).filter(function(btn){
      var card = btn.closest('[data-pdp-media-item]');
      return card && !card.classList.contains('is-filtered-out');
    });
  }
  function openAt(index){
    var list = sources();
    if (!list.length) return;
    current = Math.max(0, Math.min(index, list.length - 1));
    img.src = list[current].dataset.lightboxSrc;
    lightbox.hidden = false;
    document.documentElement.classList.add('amarelle-pdp-lightbox-open');
    document.body.classList.add('amarelle-pdp-lightbox-open');
  }
  function close(){
    lightbox.hidden = true;
    img.src = '';
    document.documentElement.classList.remove('amarelle-pdp-lightbox-open');
    document.body.classList.remove('amarelle-pdp-lightbox-open');
  }
  function move(dir){
    var list = sources();
    if (!list.length) return;
    current = (current + dir + list.length) % list.length;
    img.src = list[current].dataset.lightboxSrc;
  }
  root.querySelectorAll('[data-pdp-lightbox-open]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var list = sources();
      openAt(list.indexOf(btn));
    });
  });
  lightbox.querySelector('[data-lightbox-close]').addEventListener('click', close);
  lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', function(){ move(-1); });
  lightbox.querySelector('[data-lightbox-next]').addEventListener('click', function(){ move(1); });
  document.addEventListener('keydown', function(e){ if (lightbox.hidden) return; if(e.key === 'Escape') close(); if(e.key === 'ArrowLeft') move(-1); if(e.key === 'ArrowRight') move(1); });
})();

(function(){
  var grids = document.querySelectorAll('[data-amarelle-random-related]');
  grids.forEach(function(grid){
    var limit = parseInt(grid.dataset.amarelleRelatedLimit || '4', 10);
    var cards = Array.prototype.slice.call(grid.children);
    if (!cards.length) return;
    cards.sort(function(){ return Math.random() - 0.5; });
    cards.forEach(function(card, index){
      grid.appendChild(card);
      if (index >= limit) card.style.display = 'none';
    });
  });
})();

(function(){
  var section = document.querySelector('[data-amarelle-recently-viewed]');
  if (!section) return;
  var key = 'amarelle-recently-viewed';
  var currentId = section.dataset.productId;
  var stored = [];
  try { stored = JSON.parse(localStorage.getItem(key) || '[]'); } catch(e) {}
  stored = stored.filter(function(p){ return String(p.id) !== String(currentId); });
  stored.unshift({ id: currentId, title: section.dataset.productTitle, url: section.dataset.productUrl, price: section.dataset.productPrice, image: section.dataset.productImage });
  stored = stored.slice(0, 8);
  try { localStorage.setItem(key, JSON.stringify(stored)); } catch(e) {}
  var show = stored.filter(function(p){ return String(p.id) !== String(currentId); }).slice(0, 6);
  if (!show.length) return;
  var cards = show.map(function(p){
    return '<a href="' + p.url + '" class="amarelle-rv-card"><div class="amarelle-rv-card__media">' + (p.image ? '<img src="' + p.image + '" alt="' + p.title.replace(/"/g,'&quot;') + '" loading="lazy">' : '') + '</div><div class="amarelle-rv-card__title">' + p.title + '</div><div class="amarelle-rv-card__price">' + p.price + '</div></a>';
  }).join('');
  section.innerHTML = '<div class="amarelle-pdp-recent__shell"><header class="amarelle-pdp-recent__head"><p class="amarelle-eyebrow">' + (section.dataset.eyebrow || 'Seen before') + '</p><h2>' + (section.dataset.title || 'Recently viewed') + '</h2></header><div class="amarelle-pdp-recent__grid">' + cards + '</div></div>';
  section.style.display = 'block';
})();

(function(){
  var section = document.querySelector('[data-amarelle-recommended]');
  if (!section || !window.fetch) return;
  var id = section.dataset.productId;
  var limit = section.dataset.limit || 4;
  fetch('/recommendations/products.json?product_id=' + id + '&limit=' + limit + '&intent=related')
    .then(function(r){ return r.json(); })
    .then(function(data){
      if (!data.products || !data.products.length) return;
      var cards = data.products.map(function(p){
        var img = p.featured_image ? '<img src="' + p.featured_image + '&width=520" alt="' + p.title.replace(/"/g,'&quot;') + '" loading="lazy">' : '';
        return '<a class="amarelle-rv-card" href="' + p.url + '"><div class="amarelle-rv-card__media">' + img + '</div><div class="amarelle-rv-card__title">' + p.title + '</div><div class="amarelle-rv-card__price">' + (p.price ? ((window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(p.price, ('{' + '{amount}' + '}')) : ('€' + (Number(p.price || 0) / 100).toFixed(2).replace('.', ','))) : '') + '</div></a>';
      }).join('');
      section.innerHTML = '<div class="amarelle-pdp-recommended__shell"><header class="amarelle-pdp-recommended__head"><p class="amarelle-eyebrow">' + (section.dataset.eyebrow || 'Picked for you') + '</p><h2>' + (section.dataset.title || 'Recommended') + '</h2></header><div class="amarelle-pdp-recent__grid">' + cards + '</div></div>';
      section.style.display = 'block';
    })
    .catch(function(){});
})();

  } catch(e) { console.error(e); }
})();
})();
